module.exports = "/static/assets/dba629c24296756d68a135988fe96011.svg";